import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface SubtaskItem {
  id?: number;
  title: string;
  sortIndex: number;
  completedAt?: string | null;
}

interface SubtasksListProps {
  subtasks: SubtaskItem[];
  isArchived: boolean;
  onToggle: (index: number) => void;
}

export const SubtasksList: React.FC<SubtasksListProps> = ({ subtasks, isArchived, onToggle }) => {
  if (!subtasks.length) {
    return <Text style={styles.empty}>No subtasks to show</Text>;
  }

  const completed = subtasks.filter(s => !!s.completedAt).length;
  const percent = Math.round((completed / (subtasks.length || 1)) * 100);

  return (
    <View>
      <View style={styles.progressTrack}>
        <View style={[styles.progressFill, { width: `${percent}%` }]} />
      </View>
      <View style={{ height: 8 }} />
      <View style={styles.list}>
        {subtasks.map((st, idx) => (
          <TouchableOpacity key={`${st.title}-${st.sortIndex}`} style={styles.row} disabled={isArchived} onPress={() => onToggle(idx)}>
            <View style={[styles.checkbox, !!st.completedAt && styles.checkboxChecked]} />
            <Text style={[styles.title, !!st.completedAt && styles.completed]}>{st.title}</Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  empty: {
    color: ADMIN_COLORS.TEXT_TERTIARY,
    fontSize: 12,
  },
  progressTrack: {
    height: 6,
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: ADMIN_COLORS.PRIMARY,
  },
  list: {
    gap: 8,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  checkbox: {
    width: 16,
    height: 16,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    borderRadius: 3,
  },
  checkboxChecked: {
    backgroundColor: ADMIN_COLORS.PRIMARY,
    borderColor: ADMIN_COLORS.PRIMARY,
  },
  title: {
    color: ADMIN_COLORS.TEXT.PRIMARY,
    fontSize: 14,
  },
  completed: {
    color: ADMIN_COLORS.TEXT_TERTIARY,
    textDecorationLine: 'line-through',
  },
});


